module.exports = __webpack_public_path__ + "media/assets/images/flags/nc-1c7bb88dfa00746029d91b116c74f4d7.svg";